import React from "react";
import "../styles/Pages.css";

function About() {
  return (
    <main className="page-content">
      <section className="page-header">
        <h1 className="section-title">About Us</h1>
      </section>

      <section className="page-body">
        <div className="about-section">
          <h2>Our Story</h2>
          <p>
            Inspired by the profound vision of H.D.H Param Pujya Hariprasad
            Swamiji Maharaj and guided by the divine leadership of Pragat
            Guruhari H.D.H Param Pujya PrabodhJivan Swamiji Maharaj, the
            HariPrabodham Community is dedicated to empowering the next
            generation. We believe in building a society where youth don't just
            exist, but thrive.
          </p>
          <p>
            Our work is a living testament to the tireless efforts of both
            Guruhari Hariprasad Swamiji and Pragat Guruhari PrabodhJivan
            Swamiji, who have worked relentlessly for youth outreach and
            societal betterment. We're committed to nurturing a generation that
            values compassion, respect, and a deep sense of responsibility.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Mission in Action</h2>
          <p>
            A central tenet of our mission is to unite hearts and minds across
            the globe. We organize massive international youth festivals, known
            as HariPrabodham Yuva Mahotsav, to spread the message of Guruhari
            Hariprasad Swamiji and offer our heartfelt gratitude to Pragat
            Guruhari PrabodhJivan Swamiji for continuing this incredible legacy.
          </p>
          <p>
            These festivals are more than just events; they're powerful
            platforms for connection, inspiring thousands of young people to
            embrace the principle of 'Atmiyata' and realize that we are all part
            of one global family.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Guiding Principles</h2>
          <div className="principles-grid">
            <div className="principle-card">
              <h3>Seva</h3>
              <h4>Selfless Service</h4>
              <p>
                We believe true fulfillment comes from giving back. Our
                community engages in meaningful service projects that not only
                improve our surroundings but also help us discover a deeper
                sense of spiritual purpose.
              </p>
            </div>

            <div className="principle-card">
              <h3>Smruti</h3>
              <h4>Contemplation and Reflection</h4>
              <p>
                We honor the rich legacy and invaluable guidance of our saints.
                Our weekly gatherings, spiritual retreats, and youth conventions
                are designed to help you internalize these teachings and build a
                spiritual foundation that lasts a lifetime.
              </p>
            </div>

            <div className="principle-card">
              <h3>Suhradbhav</h3>
              <h4>Unity and Friendship</h4>
              <p>
                At the heart of our community is a spirit of genuine
                camaraderie. We actively create a welcoming environment where
                everyone feels valued and supported, forging strong friendships
                and mentorships that last a lifetime.
              </p>
            </div>

            <div className="principle-card">
              <h3>Swadharma</h3>
              <h4>Personal Integrity</h4>
              <p>
                Beyond upholding universal principles of Dharma, we guide each
                individual to hone their Swadharma—their unique moral compass
                and life's purpose. We emphasize self-control and clarity,
                empowering you to navigate life with direction.
              </p>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h2>Join Our Community</h2>
          <p>
            Become a part of a community dedicated to growth, service, and
            creating a brighter future for all.
          </p>
          <p>
            Email:{" "}
            <a href="mailto:369@ihariprabodham.org">369@ihariprabodham.org</a>
          </p>
        </div>
      </section>
    </main>
  );
}

export default About;
